export interface IChainEndOffers {
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    recipientCenterId: number,
    recipientCenterAlias: string,
    recipientId: number,
    recipientAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorId: number,
    donorAlias: string,
    isAccepted: boolean,
    decision: string,
    donationTypeId: number,
    donationType: string
}